import React from "react";
import Banner from "../../components/Banner";
import IntroductionContent from "../../components/IntroductionContent";
import LoginContent from "./parts/Content";
const env = process.env.REACT_APP_ENVIRONMENT ?? "production";

export default function Login() {
    if (env !== "local") {
        // Redirect to ouders en onderwijs landing page
        window.location.replace("https://oudersenonderwijs.nl/landelijk-ouderpanel#register_form");
        return (
            <div style={{ width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <p>Redirecting to Ouders en Onderwijs</p>
            </div>
        );
    }

    return (
        <section className="register">
            <Banner component={<LoginContent />} />

            <IntroductionContent />
        </section>
    );
}
